import { MessageCircle, Trash2 } from "lucide-react";
import type { MooChat } from "../../types/moo";

/** This profile's past Moo conversations, to reopen or delete. */
export default function MooChatList({ chats, onOpen, onDelete }: {
  chats: MooChat[];
  onOpen: (chat: MooChat) => void;
  onDelete: (chat: MooChat) => void;
}) {
  return (
    <div className="moo-chat-list">
      <h3>Your conversations</h3>
      {!chats.length && <p>No saved chats yet.</p>}
      {chats.map((c) => (
        <div key={c.id}>
          <button
            onClick={() => onOpen(c)}
          >
            <MessageCircle size={18} />
            <span>
              {c.title}
              <small>
                {new Date(c.updated_at).toLocaleDateString()}
              </small>
            </span>
          </button>
          <button
            aria-label={`Delete ${c.title}`}
            onClick={() => onDelete(c)}
          >
            <Trash2 size={18} />
          </button>
        </div>
      ))}
    </div>
  );
}
